import type { ListChipFilterConfig } from '../../../List/filters/ListChipFilters/ListChipFilters.tsx';
import type { SeatTransferListFilters } from './types.ts';

export const chipFiltersConfig: Record<keyof SeatTransferListFilters, ListChipFilterConfig> = {
  buyer_id: {
    displayName: 'Seat ID',
    isTextInput: true,
  },
  demand_partner_id: {
    displayName: 'DSP ID',
    isTextInput: true,
  },
};
